










































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateActivity } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constan from '@/utils/constant'

@Component({
  components: { VImageUpload },
})
export default class CreateActivityDialog extends Vue {
  private show = false
  private data = {
    activityType: 0,
    activityLabel: '限时抢购',
    activityImgList: [],
    activityImg: '',
    maxQty: 0,
    activityBannerImg:'',
    activityBannerImgList:[],
    zoneDistributionFlag: 0
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activityName: [this.requiredRule],
    startTime: [this.requiredRule],
    endTime: [this.requiredRule],
  }
  private activityType = constan.GoodsActivityType

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  public open() {
    this.show = true
    this.data = {
      activityType: 1,
      activityLabel: '普通活动',
      activityImgList: [],
      activityImg: '',
      maxQty: 0,
      activityBannerImg:'',
      activityBannerImgList:[],
      zoneDistributionFlag: 0
    }
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.activityImg = this.data.activityImgList.map((e: any) => e.url).join(',')
      this.data.activityBannerImg = this.data.activityBannerImgList.map((e: any) => e.url).join(',')

      await CreateActivity(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
